import axiosInstance from '../config/axios';

export const getCartItems = async (userId) => {
  return axiosInstance.get(`/cart/user/${userId}`);
};

export const addItemToCart = async (itemData) => {
  return axiosInstance.post(`/cart`, itemData);
};

export const removeCartItem = async (itemId) => {
  return axiosInstance.delete(`/cart/${itemId}`);
};

export const processBooking = async (paymentData) => {
  return axiosInstance.post(`/bookings`, paymentData);
};

export const renewBookingSubscription = async (data, subscriptionId) => {
  return axiosInstance.post(`/bookings/${subscriptionId}/renew`, data);
}